export enum TrackingType {
    /**
     * Originates from frontend.
     *
     * The user visits a document.
     */
    VISIT = 'VISIT',

    /**
     * Originates from fe-backend-gw.
     *
     * The user downloads a document from the frontend.
     */
    DOWNLOAD = 'DOWNLOAD',

    /**
     * Originates from customer-api-gw.
     *
     * The user downloads a document from the customer-api-gw.
     */
    API = 'API'
}
